import { combineReducers } from 'redux'

import authReducer from './auth'
import claimReducer from './claim'
import abTestReducer from './abtest'
import lotsReducer from './lots'
import newsReducer from './news'
import fundsReducer from './funds'
import personsReducer from './persons'
import contactsReducer from './contacts'
import commentsReducer from './comments'
import localesReducer from './i18n'
import { intlReducer } from 'react-intl-redux'
//
import home from './home'
import doc from './static'
import login from './login'
import about from './about'
import search from './search'
import payment from './payment'
import faq from './about/index'
import liteFundlist from './liteFundlist'
import partners from './partners'
import feedback from './feedback'
import countries from './countries'
import categories from './categories'
import profile from './profile/index'
import paymentMethods from './paymentMethods'
import checkout from './checkout'
import giftcards from './giftcards'
import CP from './CP'
import visit from './visits'
import visitsOfPerson from './visitsOfPerson'
import personProfile from './personProfile'
import heroRequests from './heroRequests'

export default asyncReducers => combineReducers({
  auth: authReducer,
  claim: claimReducer,
  lots: lotsReducer,
  news: newsReducer,
  funds: fundsReducer,
  contacts: contactsReducer,
  comments: commentsReducer,
  persons: personsReducer,
  intl: intlReducer,
  locales: localesReducer,
  abtest: abTestReducer,
  //
  doc,
  home,
  about,
  login,
  search,
  payment,
  profile,
  personProfile,
  partners,
  faq,
  liteFundlist,
  visit,
  feedback,
  countries,
  categories,
  paymentMethods,
  checkout,
  giftcards,
  CP,
  visitsOfPerson,
  heroRequests,
  //
  // ...asyncReducers
})



// WEBPACK FOOTER //
// ./src/store/reducers/index.js